import styled from 'styled-components';

export const CenteredSpaceWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:space-between;
    `,
);

export const CenteredDivWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:center;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const FlexItem = styled.div(
  props => `
    display:flex;
    `,
);

export const FlexCentered = styled.div(
  props => `
    display:flex;
    align-items:center;
    `,
);

/***** Heading Text *****/

export const SectionHeader = styled.h3(
  props => `
    font-weight: bold;
    font-size: ${props.theme.font.custom(22)};
    font-family: ${props.theme.font.fontFamily};
    `,
);

export const SmallSectionHeader = styled.h4(
  props => `
    font-weight: bold;
    font-size: ${props.theme.font.large};
    font-family: ${props.theme.font.fontFamily};
    `,
);

/**** anchor link ****/

export const PrimaryLink = styled.a(
  props => `
    color:${props.theme.colors.goBrandBlue.base};
  `,
);

/**** circular background of arrow icon */

export const CircularDiv = styled.div(
  props => `
  width:2.6rem;
  height:2.6rem;
  background-color: ${props.theme.colors.ash.medium};
  border-radius:50%;
  cursor:pointer;
`,
);

/***** Button basic styles */

export const ButtonBase = styled.button(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.theme.colors.goBrandOrange.base};
    color: ${props.theme.colors.goWhite.base};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    text-transform: uppercase;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-size:${props.theme.font.custom(16)};
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);
